<template>
  <ListingPageDescription :view="view">
    <div v-if="view.originalUrl" class="container description__url">
      <a target="_blank" :href="view.originalUrl" rel="noreferrer noopener">
        Listen to the original
      </a>
    </div>
    <div class="container">
      <PodcastFollowButton :view="view.followView" />
    </div>
  </ListingPageDescription>
</template>
<script setup lang="ts">
import ListingPageDescription from './ListingPageDescription.vue'
import PodcastFollowButton from '@/app/components/listing/PodcastFollowButton.vue'

import type { ListDescriptionViewPodcast } from '@/models/docs.list.podcasts.episodes'

defineProps<{
  view: ListDescriptionViewPodcast
}>()
</script>

<style scoped lang="scss">
.episodes__item {
  position: relative;
}

:deep(.description__name) {
  display: block;
}

:deep(.description__img-box) {
  display: block;
}

// We only show the podcast title when the header is collapsed
:deep(.header--default .header__title-wrapper) {
  display: none;
}

// We only show the podcast actions when the header is collapsed
:deep(.header--default .header__actions) {
  display: none;
}

:deep(.header--default .header__back) {
  margin-bottom: 0px;
}

.podcast-follow-btn-wrapper {
  margin-top: 40px;
}
</style>
